/**
 * CSS ellipsis detection based on: https://stackoverflow.com/a/72637621
 */
const isEllipsisActive = (element: HTMLElement | null | undefined) => {
    if (!element) {
        return false;
    }

    const clonedElement = element.cloneNode(true) as NonNullable<
        typeof element
    >;

    clonedElement.classList.add('fixed', 'invisible', 'overflow-visible');

    element.parentElement?.appendChild(clonedElement);

    try {
        const fullWidth = clonedElement.getBoundingClientRect().width;
        const displayWidth = element.getBoundingClientRect().width;

        return fullWidth > displayWidth;
    } finally {
        clonedElement?.remove();
    }
};

export default isEllipsisActive;
